// extracted by mini-css-extract-plugin
export default {"container":"DSIProductTour_container__g-PAB","list":"DSIProductTour_list__C50SC"};